var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1VenetianBlindUpBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.93 20H27.07L38 9l10.93 11zM17 33h42v-6H17v6zm0 10h42v-6H17v6zm0 10h42v-6H17v6zm0 10h42v-6H17",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Venetian_blind_up_bis.faff8201.svg";
export { SvgC1VenetianBlindUpBis as ReactComponent };